module.exports = __webpack_public_path__ + "img/sheet.af5028ae.png";